import React, { useState } from 'react';
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'

const accordionData = [
  {
id:1,
title:"Air Source Heat Pump",
content:"Industrial air‑source heat pumps extract heat from ambient or exhaust air and upgrade it to hot water or hot air using a closed vapour‑compression cycle.They are ideal where there is reliable outdoor air or warm exhaust air from refrigeration and process equipment. Typical uses include food plants, warehouses and process facilities needing both space heating and hot water."
}, 
{
id:2,
title:"Water Source Heat Pump",
content:"Water‑source heat pumps use process water, condenser water, cooling‑tower circuits, rivers or wells as a stable heat source for high efficiency.They are especially attractive wherever warm wastewater or large refrigeration plants already exist. Typical applications include dairies, breweries, beverages and pharma plants recovering heat from condensers and process water."
}, 
{
id:3,
title:"Dual Source Heat Pump",
content:"Dual‑source heat pumps combine air and water heat sources in one system and automatically select or blend them for the best efficiency and uptime.They prioritize warm process water or wastewater when available and switch to ambient air when water temperature or flow is insufficient. This configuration suits plants with intermittent waste‑heat streams and variable outdoor conditions."
}, 
{
id:4,
title:"Hybrid Heat Pump",
content:"Hybrid mechanical heat pumps integrate vapour‑compression units with other heat sources or systems such as boilers, absorption stages or district heat.They allow intelligent load sharing so that boilers handle peak or very high temperatures while the heat pump covers base load efficiently. This is ideal for steam‑based plants seeking staged decarbonization without sacrificing process reliability."
},
]


function HeatPumps() {
 useGaspAnimations()
    
 const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };


    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Heat Pumps</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li><a href="services.html">Services</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Heat Pumps</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start service single area--> */}
<section id="service-single-area">
    <div className="container">
        <div className="row">
            <ProductFilter/>     
            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                <div className="service-single-content">
                    {/* <!--Start top content --> */}
                    <div className="row top-content">
                        <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle bdFadeLeft">
                          <img src="assets/images/OurProducts/Heat-Pumps.webp" alt="Awesome Image"/>
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="textholder">
                                <div className="title bdFadeUp sec-title">
                                    <h1><span>Heat Pumps</span></h1>
                                </div>
                                <div className="text bdFadeUp">
                                    {/* <span>We Are professional. Reliable and Affortable</span> */}
                                    <p className="top">
                                     Mechanical vapour‑compression heat pumps upgrade low‑temperature heat into useful hot water or process heating by circulating a refrigerant in a closed cycle of compression, condensation, expansion and evaporation. For industrial users, this means lower fuel consumption, reduced carbon emissions and tighter temperature control for processes in food, dairy, chemicals, pharmaceuticals and general manufacturing
                                    </p>

                                        <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                                    {/* <p>Who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a annoying consequences resultant pleasure.</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--End top content --> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>
                    {/* <!--Start middle content--> */}
                    <div className="row middle-content">
                        <div className="col-md-7">
                            <div className="text-holder">
                                <div className="title bdFadeUp">
                                    <h2>Sub-category</h2>
                                </div>
                                <div className="text">
                                    {/* <p>Don't spend time and money on beautiful landscaping if you have not taken water and irrigation issues into account first. Installing a sprinkler system, leveling the ground.</p> */}
                                    <ul>
                                         <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Air Source Heat Pump</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Water Source Heat Pump</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Dual Source Heat Pump</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Hybrid Heat Pump</li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 bdFadeUp">
                                <img src="assets/images/OurProducts/heatpump/01.jpg" alt="Awesome Image"/>
                        </div>
                    </div>
                    {/* <!--End middle content--> */}
                     {/* <!--Start bottom content--> */}
                    <div className="row bottom-content">
                        <div className="col-md-12">
                            <div className="title bdFadeUp">
                                    <h2>Sub-category Descriptions</h2>
                                </div>
                            <div className="accordion-box bdFadeUp">
                                {accordionData.map(({ id, title, content }) => (
                                <>
                                 {/* <!--Start single accordion box--> */}
                                <div className="accordion accordion-block" key={id}>
                                    <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                    {openSections[id] && (
                                    <div className="accord-content collapsed">
                                        <p>
                                        {content}
                                        </p>
                                    </div>
                                    )}
                                </div>
                                 {/* <!--End single accordion box-->  */}
                                </>
                                ))}
                        </div>
                    </div>
                </div>
                    {/* <!--End bottom content--> */}

                    {/* <!--Start Consultation form--> */}
                   
                    {/* <!--End Consultation form--> */}
                </div>
            </div>
  
            
        </div>
    </div>    
</section>
{/* <!--End service single area--> */}
   <MakeAppoinment/>
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default HeatPumps;


